import { Navigate } from "react-router-dom";

import { useCurrentUser } from "@/hooks/useCurrentUser";

interface RequirePermissionProps {
  perm: string;
  redirectTo: string;
  children: React.ReactNode;
}

/**
 * Route guard mirroring the server's requirePermission. UX only — the server is
 * the real gate. While the session is loading, render nothing (no flash). When
 * the permission is absent, redirect; otherwise render the children.
 */
export function RequirePermission({ perm, redirectTo, children }: RequirePermissionProps) {
  const { status, permissions } = useCurrentUser();
  if (status === "loading") return null;
  if (!permissions.includes(perm)) return <Navigate to={redirectTo} replace />;
  return <>{children}</>;
}
